import './TinhNang.scss'

function TinhNang () {
  return (
    <section className='sec_adventure'>
      <div className='heading'>
        <img src='/tinhnang.png' alt='' />
      </div>

      <ul className='ul_hotgame'>
        <li>
          <img src='/iconruttt.png' alt='' />
          <h3>ฝาก/ถอน รวดเร็วทันใจ</h3>
          <p>
            รองรับช่องทางที่หลากหลาย ใช้งานง่าย และดำเนินการอย่างรวดเร็ว -
            ทุกธุรกรรมของท่านจะได้รับการดำเนินการด้วยความรวดเร็วที่สุด
          </p>
        </li>

        <li>
          <img src='/iconbadge.png' alt='' />
          <h3>ยุติธรรม & โปร่งใส</h3>
          <p>
            มั่นใจในการจ่ายรางวัลอย่างรวดเร็ว ผลลัพธ์มีความโปร่งใส
            ชัดเจน และส่งตรงจากผู้ให้บริการและผู้จัดการแข่งขัน
          </p>
        </li>

        <li>
          <img src='/iconsafety.png' alt='' />
          <h3>ปลอดภัย & เป็นส่วนตัว</h3>
          <p>
            ข้อมูลทั้งหมดบน QK88BET ได้รับการปกป้องด้วยระบบความปลอดภัย
            เพื่อรักษาความเป็นส่วนตัวและความปลอดภัยของข้อมูลผู้เล่น
          </p>
        </li>

        <li>
          <img src='/iconcontact.png' alt='' />
          <h3>บริการออนไลน์ตลอด 24 ชั่วโมง</h3>
          <p>
            ทีมงานมืออาชีพ พร้อมให้คำแนะนำและช่วยเหลือตลอดเวลา -
            QK88BET พร้อมตอบทุกคำถามและให้ความช่วยเหลือแก่ลูกค้า
          </p>
        </li>
      </ul>
    </section>
  )
}

export default TinhNang